import React, { useEffect, useState } from "react";
import {
    FaUser,
} from "react-icons/fa";
import tw from "tailwind-styled-components";
import { MdOutlineChevronRight } from "react-icons/md";

function SummaryCards({ summaryData, onClick, setSelectedId, selectedId }) {
    // const [selectedId, setSelectedId] = useState(null);

    // useEffect(() => {
    //     setSelectedId(null);
    // }, [summaryData]);

    const currentMonthName = new Date().toLocaleString("default", {
        month: "short",
    });
    
    const summary = [
        {
            amount: summaryData?.totalMovedOut || 0,
            label: `Total Move-Outs`,
            color: "text-black",
            icon: <FaUser size={20} className="text-blue-400" />,
            filter: 'E',
        },
        {
            amount: summaryData?.cancelledBooking || 0,
            //label: `${currentMonthName} Months`,
            label: 'Cancelled Bookings',
            color: "text-black",
            icon: <FaUser size={20} className="teal-yellow-400" />,
            filter: 'CB',
        },
        {
            amount: summaryData?.defaulters || 0,
            subTitle: (summaryData?.totalDefaultedDues || 0),
            label: `Defaulters`,
            color: "text-black",
            icon: <FaUser size={20} className="text-red-400" />,
            filter: 'ED',
        },
        {
            amount: summaryData?.workingPending || 0,
            label: `FnF Pending`,
            color: "text-black",
            icon: <FaUser size={20} className="text-red-400" />,
            filter: 'WP',
        },
    ];
    return (
        <Wrapper>
            <ScrollCard
                style={{
                    scrollBehavior: "smooth",
                }}
            >
                {summary.map((item, index) => (
                    // <Card selectedId={selectedId} 
                    // index={index} key={index} onClick={() => {
                    //     setSelectedId(index);
                    //     onClick(item.filter);
                    // }
                    // }>
                    <Card
                        key={item.label}
                        $selected={selectedId === index}
                        onClick={() => {
                            setSelectedId(index);
                            onClick(item.filter);
                        }}
                    >
                        <ValueRow>
                            <div className='flex flex-row'>
                                <Value color={item.color}>{item.amount}</Value>
                                {item.subTitle &&
                                    <span className="ml-1 mt-auto text-sm text-gray-600 align-middle mb-1">{"(₹" + item.subTitle + ")"}</span>
                                }
                            </div>

                        </ValueRow>
                        <Label>
                            {item.label}
                            <ArrowWrap className="arrow">
                                <Chevron />
                            </ArrowWrap>
                        </Label>
                    </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
}
const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1`;
// const Card = tw.div`min-w-[200px] p-3 rounded-md bg-white shadow-md cursor-pointer hover:shadow-sm hover:shadow-primary-color  ${({ selectedId, index }) => selectedId === index ? "shadow-sm shadow-primary-color" : ""}`;
// const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between break-words whitespace-normal w-full`;
// const Value = tw.p`
//   text-xl sm:text-2xl font-bold  
//   ${({ color }) =>
//         color}
// `;

const Card = tw.div`
  group min-w-[200px]
  rounded-lg bg-white
  p-4 cursor-pointer
  border border-gray-100
  shadow-sm
  transition-all duration-200
  hover:shadow-md hover:border-gray-200
  ${({ $selected }) =>
        $selected
            ? "border-primary-color shadow-md"
            : ""}
`;


const ValueRow = tw.div`
  flex items-baseline gap-1
`;

const Value = tw.div`
  text-2xl font-semibold text-gray-900
`;

const Label = tw.div`
  flex  mt-2 text-sm text-gray-500 items-center justify-between
`;

const ArrowWrap = tw.div`
  flex items-center
  text-gray-300
  transition-all duration-200
`;

const Chevron = tw(MdOutlineChevronRight)`
  text-lg
  transform translate-x-0
  opacity-60
  group-hover:opacity-100
  group-hover:text-gray-500
  group-hover:translate-x-1
`;
export default SummaryCards;

